function isMobile() {
  return this.$vuetify.breakpoint.xs;
}

export default isMobile;
